import { Form, Input, message, AutoComplete, Checkbox } from "antd";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { sendCode, queryWxCode, queryWxCallbackUrl } from "@api/login";
// import { getCurrentUserInfo } from "@api/user";
import { setCookie, judge, isPrefix } from "@util/utils";
import "./login_interceptor.less";
import SliderModal from "./react-slider-vertify/slider";
// import pzLogo from "@assets/images/pz-logo.png";
import wxLogo from "@assets/images/wx-logo.png";
import { getProtocolUrl, ym_url } from '@util/enum'
import loginContext from "@components/login_context";
import Captcha from '@pages/aliyun_captcha/App';
import uuid from 'react-uuid'
import { Trans, useTranslation } from "react-i18next";
import Iconfont from "@components/iconfont/iconfont";
import { debounce } from "lodash";
import SpinLoading from '@components/spin_loading'
import { saveLoginModalWechatReturnContext } from "@components/login_modal/wechatReturn";
import H5LoginOptions from "./h5_login_options";
import H5FormError from "./h5_form_error";
import FormFieldError from "@components/form_field_error";
let timer
const getAgreementHref = (fileUrl) =>
  `/agreement.html?fileUrl=${encodeURIComponent(fileUrl)}`;
export default function LoginRegistModal({
  setVisible,
  setForgetPWDVisible,
  setOtherLoginVisible,
  setLoginName,
  pwdLogin,
  setPwdLogin,
  serDirect,
  isShop,
  shopPlatFun,
}) {
  const { t, i18n } = useTranslation()
  const getLocalizedAgreementHref = (protocolKey) =>
    getAgreementHref(
      getProtocolUrl(
        protocolKey,
        i18n?.resolvedLanguage || i18n?.language
      )
    );
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [fieldErrors, setFieldErrors] = useState({
    sms: {},
    password: {},
  });
  const [unicode, setUcode] = useState("");
  const [tipName, setTipName] = useState("发送验证码");
  const [disabled, setDisabled] = useState(false);
  // const [interval, set_interval] = useState(null);
  const [slider, setSlider] = useState(false);
  const [sliderVisible, setSliderVisible] = useState(false);
  const [sendNum, setSendNum] = useState(0);
  const [time, setTime] = useState(0);
  const [options, setOptions] = useState([]);
  const prefix = isPrefix()
  const reg = /^1[3-9][0-9]\d{8}$/;
  const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const prefixReg = /^\+86[- ]*/;
  const {
    platform,
    identityType,
    loginApi,
    loginSucCallback,
    getUrlByHadParam,
    handleSearch,
    devicePlatform,
    isPhone,
    isPhoneWx,
    privateMemberOpen,
    privateMemberOpenStatusLoaded,
    privateMemberTeamId,
    privateMemberInviterId,
    privateMemberSource,
    privateTeamName,
    previewPrivateAgreement,
  } = useContext(loginContext);
  const isWx = judge();
  // Only unprefixed H5 inside WeChat uses the new login options layout.
  const isPrefixedH5 = (isPhone && Boolean(prefix)) || !isPhone;
  const showH5LoginOptions = isPhone && !prefix && isWx;
  const showLegacyLoginOptions = isPrefixedH5 || (isPhone && !isWx);
function ContractLinks({ contracts = [], language, t }) {
  const getSeparator = (index) => {
      return index === contracts.length - 1 ?  t("最后一个协议和倒数第二个协议连接的文案") : t("两个协议之间连接的文案");
  };

  return (
    <>
      {contracts.map((contract, index) => (
        <React.Fragment key={`${contract.type}-${contract.url}`}>
          {getSeparator(index)}
          <a
            href={getAgreementHref(contract.url)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(`《${TEAM_VIP_CONTRACT_LABELS[contract.type]}》`)}
          </a>
        </React.Fragment>
      ))}
    </>
  );
}
  const updateFieldErrors = (formKey, fields = []) => {
    const errors = {};
    fields.forEach((field) => {
      const fieldName = Array.isArray(field.name)
        ? field.name.join(".")
        : field.name;
      if (fieldName) {
        errors[fieldName] = field.errors || [];
      }
    });
    setFieldErrors((current) => ({
      ...current,
      [formKey]: errors,
    }));
  };
  const handleFieldsChange = (formKey, _changedFields, allFields) => {
    updateFieldErrors(formKey, allFields);
  };
  const handleFinishFailed = (formKey, { errorFields = [] } = {}) => {
    updateFieldErrors(formKey, errorFields);
  };
  const renderFieldError = (formKey, fieldName) => {
    const error = fieldErrors[formKey]?.[fieldName]?.[0];
    // PC 端与 H5 端展示同样的异常提醒，PC 样式参考 pc-login-modal 的字段报错。
    if (!isPhone) return <FormFieldError error={error} />;
    return <H5FormError error={error} />;
  };

  const [loading, setLoading] = useState(false)
  const [agreementChecked, setAgreementChecked] = useState(false)
  const isH5PrivateScene = isPhone && privateMemberOpen;
  const showPrivateMemberAgreement = isH5PrivateScene;
  const privateMemberLoginParams = useMemo(() => {
    if (!showPrivateMemberAgreement || !agreementChecked || !privateMemberTeamId) {
      return {};
    }

    const inviterId = privateMemberInviterId ? Number(privateMemberInviterId) : null;
    const hasInviterId = inviterId !== null && !Number.isNaN(inviterId) && inviterId > 0;
    return {
      teamId: privateMemberTeamId,
      ...(hasInviterId ? { inviterId } : {}),
      ...(privateMemberSource ? { source: privateMemberSource } : {}),
    };
  }, [agreementChecked, privateMemberInviterId, privateMemberSource, privateMemberTeamId, showPrivateMemberAgreement]);
  // 微信登录沿用原设备判定（手机 + 平板）：私域会员参数与回跳保持改动前的行为，
  // 只有登录页的呈现才跟随 PC
  const privateMemberWxLoginParams = useMemo(() => {
    if (!isPhoneWx || !privateMemberOpen || !privateMemberTeamId) {
      return {};
    }

    const inviterId = privateMemberInviterId ? Number(privateMemberInviterId) : null;
    const hasInviterId = inviterId !== null && !Number.isNaN(inviterId) && inviterId > 0;
    return {
      teamId: privateMemberTeamId,
      ...(hasInviterId ? { inviterId } : {}),
      ...(privateMemberSource ? { source: privateMemberSource } : {}),
    };
  }, [isPhoneWx, privateMemberInviterId, privateMemberOpen, privateMemberSource, privateMemberTeamId]);
  const checkPrivateMemberAgreement = () => {
    if (isPhone && privateMemberTeamId && !privateMemberOpenStatusLoaded) {
      message.warning(t("\u4f1a\u5458\u72b6\u6001\u786e\u8ba4\u4e2d\uff0c\u8bf7\u7a0d\u540e"));
      return false;
    }
    if (showPrivateMemberAgreement && !agreementChecked) {
      message.warning(t("\u8bf7\u5148\u9605\u8bfb\u5e76\u540c\u610f\u76f8\u5173\u534f\u8bae"));
      return false;
    }
    return true;
  };
  const appendPrivateMemberLoginParams = (params = {}) => ({
    ...params,
    ...privateMemberLoginParams,
  });
  const appendPrivateMemberWxLoginParams = (params = {}) => ({
    ...params,
    ...privateMemberWxLoginParams,
  });
  const buildWxWebLoginUrl = (origin, key) => {
    const params = new URLSearchParams({
      key: key || "",
      platform,
    });
    Object.entries(privateMemberWxLoginParams).forEach(([name, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.set(name, value);
      }
    });
    return `${origin}/api/wx/webLogin?${params.toString()}`;
  };

  useEffect(() => {                                 
    setCookie('platform', platform, 7)
  }, [platform])
  const buttonKey = useMemo(()=>{
    return 'captcha-button-'+uuid()
  },[])
  const sendSmsCode = (res) => {
    const phone = form.getFieldValue("phone");
    if (!phone || disabled) {
      return;
    }
    if (!sendNum) {
      setTime(new Date().getTime());
    }
    setSendNum(sendNum + 1);
    let nowTime = new Date().getTime();
    if (sendNum > 4 && (nowTime - time) / 1000 < 600) {
      setSliderVisible(true);
      setSlider(true);
    }
    sendCode({
      phone,
      phoneCodeId: res.phoneCodeId
    }).then((res) => {
      if (res.success) {
        let num = 60;
        setDisabled(true);
        timer = setInterval(() => {
          if (num >= 1) {
            num -= 1;
            setTipName(num);
          }
          if (num <= 0) {
            setTipName("发送验证码");
            setDisabled(false);
            clearInterval(timer);
          }
        }, 1000)
        setUcode(res.result.unicode);
      } else {
        message.error(t(res.errorInfo||'获取验证码失败,请重新获取'))
      }

    });
  };
  const changeLogin = () => {
    setPwdLogin(!pwdLogin);
    setSliderVisible(false);
    setSlider(false);
    form.resetFields();
    setFieldErrors({ sms: {}, password: {} });
  };
  const switchToVerificationLogin = () => {
    setPwdLogin(false);
    form1.resetFields();
    setFieldErrors((current) => ({ ...current, password: {} }));
  };
  const loginOkFn = () => {
    if (!checkPrivateMemberAgreement()) {
      return;
    }
    if (isPhone && privateMemberTeamId && !privateMemberOpenStatusLoaded) {
      message.warning(t("会员状态确认中，请稍后"));
      return;
    }
    if (showPrivateMemberAgreement && !agreementChecked) {
      message.warning(t("请先阅读并同意相关协议"));
      return;
    }
    if (pwdLogin) {
      form1.submit();
    } else {
      if (slider) {
        message.warn(t("请完成拼图"));
        setLoading(false)
        return;
      }
      form.submit();
    }
  };

  const loginOk = debounce(loginOkFn, 300)

  const forgetPWD = (e) => {
    e.stopPropagation();
    form1.resetFields();
    setFieldErrors((current) => ({ ...current, password: {} }));
    setPwdLogin(!pwdLogin);
    setVisible(false);
    setForgetPWDVisible(true);
  };
  const wxauthLogin = () => {
    if (!checkPrivateMemberAgreement()) {
      return;
    }
    let url = window.location.origin;
    const host = window.location.host;
    let appid = 'wx80dfb3bc1c99533b';
    if (url.indexOf(":3001") >= 0 || url.indexOf("ngtest.guyubao.com") >= 0) {
      url = `https://${ym_url.test}`;
      // url = "http://ajf5drq9ve9w.ngrok.xiaomiqiu123.top"
    }
    if (host.indexOf('material-pre') >= 0) {
      appid = 'wx26852148b145376b';
    } else if (origin.indexOf('material-test') < 0) {
      appid = 'wx54e4bc4ffda6e5f1';
    }
    let srt = '';
    const { key, val, url: toUrl } = getUrlByHadParam(1,true);
    if (toUrl) {
      srt = toUrl
      // srt = `?type=${type}&key=${val}`;
      localStorage.setItem(key, val);
      if (key === 'clientId') localStorage.setItem('entrust', val);
    }
    
    // if(unicode_url) {
    //   srt = `?type=2&key=${unicode_url}`
    //   localStorage.setItem('unicode',unicode_url);
    // }else if(entrust) {
    //   if(entrust === clientId){
    //     srt = `?type=3&key=${entrust}`
    //     localStorage.setItem('clientId',clientId);
    //   }else{
    //     srt = `?type=4&key=${entrust}`
    //     localStorage.setItem('entrust',entrust);
    //   }
    // }else if(inviteCode) {
    //   srt = `?type=5&key=${inviteCode}`
    //   localStorage.setItem('inviteCode',inviteCode);
    // }else if(share_product) {
    //   srt = `?type=1&key=${share_product}`
    //   localStorage.setItem('share_product',share_product);
    // }else if(share_main){
    //   localStorage.setItem('share_main',share_main);
    //   srt = `?type=6&key=${share_main}`;
    // }

    // type=1:`/product_detail_share.html?id=${key}`
    // type=2:`/team_join_link.html?unicode=${key}`
    // type=3 :`/create_product.html?clientType=3&clientId=${key}&operation=CREATE&entrust=${key}`
    // type=4 :`/entrust_product.html?key=${key}`
    // type=5:`/invite_settle.html?inviteCode=${key}`
    // type=6:`/share_page.html?key=${key}&isProduct=1`
    // type=7:`/material_square.html`
    clearLocalStorage()
    if (srt) {
      queryWxCallbackUrl({ redirectUrl: srt }).then((res) => {
        if (res.success) {
          window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
            buildWxWebLoginUrl(url, res.result)
          )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
        }
      })
      return
    }
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
      buildWxWebLoginUrl(url, srt)
    )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  }
  const handleWechatLogin = (e) => {
    e?.stopPropagation();
    if (!checkPrivateMemberAgreement()) {
      return;
    }
    const { key, val, url } = getUrlByHadParam(1,true);
    const privateMemberReturnUrl =
      url || `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const shouldUseWxSucCallback = Boolean(privateMemberWxLoginParams.teamId);
    if (shouldUseWxSucCallback) {
      saveLoginModalWechatReturnContext({
        returnUrl: privateMemberReturnUrl,
        shouldJoin: true,
        ...privateMemberWxLoginParams,
      });
    }
    if (isWx) {
      wxauthLogin();
      return;
    }

    let callback = '';
    const ym = window.location.origin;
    if (url) {
      callback = ym + url;
      localStorage.setItem(key, val);
      if (key === 'clientId') localStorage.setItem('entrust', val);
    }
    const callbackTarget = shouldUseWxSucCallback
      ? `${window.location.origin}/wx_suc.html?fromLoginModal=1`
      : callback;
    const openWechatQr = (res) => {
      if (res.success) {
        setCookie('platform', platform, 90);
        clearLocalStorage();
        setLoginName("微信登录");
        setVisible(false);
        setOtherLoginVisible(true);
        setSliderVisible(false);
        setSlider(false);
        serDirect(res.result?.split("redirect:")[1]);
      } else {
        message.error(t(res.errorInfo));
      }
    };
    if (callbackTarget) {
      queryWxCallbackUrl({ redirectUrl: callbackTarget }).then((res) => {
        if (res.success) {
          queryWxCode(appendPrivateMemberWxLoginParams({ platform, callback: res.result })).then(openWechatQr);
        } else {
          message.error(t(res.errorInfo));
        }
      });
      return;
    }
    queryWxCode(appendPrivateMemberWxLoginParams({ platform, callback: callbackTarget })).then(openWechatQr);
  };
  const phone = Form.useWatch('phone',form)

  const captchaOpen = useMemo(()=>{
    return  phone && (reg.test(phone) || emailReg.test(phone)) && !disabled
  },[phone,disabled])
  const openPrivateAgreement = (contractType) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    previewPrivateAgreement?.(contractType);
  }
  const renderH5Agreement = () => (
    <div
      className="h5-private-agreement"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="h5-private-member-tip">
        {t(
            "注册不觉账号并加入 {{privateDomainName}} 会员,享受会员专属权益与服务。",
            { privateDomainName: privateTeamName }
          )}
      </div>
      <div className="h5-private-agreement-line" />
      <div
        className="h5-private-agreement-row"
        onClick={(e) => {
          if (e.target.tagName?.toLowerCase() !== "a") {
            setAgreementChecked((checked) => !checked);
          }
        }}
      >
        <Checkbox
          checked={agreementChecked}
          className="h5-private-agreement-checkbox h5-private-agreement-checkbox-circle"
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => setAgreementChecked(e.target.checked)}
        />
        <div className={`h5-private-agreement-text ${i18n.language === 'en'? 'blod_a':''}`}>
          <Trans
            i18nKey="注册登录协议说明2"
            components={{
              user: (
                <a
                  href={getLocalizedAgreementHref("user")}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              privacy: (
                <a
                  href={getLocalizedAgreementHref("privacy")}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              child: (
                <a
                  href={getLocalizedAgreementHref("child")}
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
              contracts:(<>
                <span>{t('两个协议之间连接的文案')}</span>
                <a href="#" onClick={openPrivateAgreement("VIP")}>
                  {t("《私域会员协议》")}
                </a>
                <span>{t('最后一个协议和倒数第二个协议连接的文案')}</span>
                <a href="#" onClick={openPrivateAgreement("PRIVACY")}>
                  {t("《私域隐私协议》")}
                </a>
              </>)
            }}
          />
        </div>
      </div>
    </div>
  )
  // `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx54e4bc4ffda6e5f1&redirect_uri=https%3A%2F%2Fmaterial-test.bujue.art%2Fapi%2Fwx%2FwebLoginq967qjtS%26platform%3DMATERIAL_H5&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`
  return (
    <div className={isPhone ? "boxMask phoneLoginMask" : "boxMask"}>
      <div
        className={`${isPhone ? "boxContent phoneLoginContent" : "boxContent"}${
          showH5LoginOptions ? " h5-login-options-fixed" : ""
        }`}
      >
        <div className="text_title">
          <span className={!pwdLogin ? "" : "dn"}>{t(isPhone ? "验证码登录" : "登录/注册")}</span>
          <span className={pwdLogin ? "" : "dn"}>{t(isPhone ? "密码登录" : "登录")}</span>
        </div>
        {/* <span className={!pwdLogin ? "text_tip" : "dn"}>
          验证即登录，未注册将自动创建不觉空间艺术馆账户
        </span> */}
        <Form
          className={!pwdLogin ? "db" : "dn"}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 20 }}
          form={form}
          onFinish={(data) => {
            let params = appendPrivateMemberLoginParams({
              ...data,
              unicode,
              loginType: "SMS",
              redirectUrl: "/team_home.html",
            });
            if (identityType) params = { ...params, identityType: 2 }
            setLoading(true)
            loginApi(params, (res) => {
              setLoading(false)
              if (isShop) {
                shopPlatFun(res.token);
                return;
              }
              setDisabled(false);
              setTipName("发送验证码");
              clearInterval(timer);
              loginSucCallback(res);
            }, isShop,()=>{
              setLoading(false)
            })
          }}
          validateTrigger="onBlur"
          onFieldsChange={(changedFields, allFields) =>
            handleFieldsChange("sms", changedFields, allFields)
          }
          onFinishFailed={(info) => handleFinishFailed("sms", info)}
        >
          <Form.Item
            name="phone"
            wrapperCol={{ offset: 2, span: 20 }}
            help={renderFieldError("sms", "phone")}
            getValueFromEvent={(value) => {
              if (prefixReg.test(value)) {
                return value.replace(prefixReg, '');
              }
              return value;
            }}
            rules={[
              {
                required: true,
                message: t("请输入正确的手机号或邮箱账号!"),
              },
              () => ({
                validator(_, value) {
                  let new_value = value;
                  if (prefixReg.test(value)) {
                    new_value = value.replace(prefixReg, '')
                  }
                  if (reg.test(new_value) || emailReg.test(new_value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("请输入正确的手机号或邮箱账号!")));
                },
              }),
            ]}
          >
            {/* <Input placeholder={i18n?.language=='en'?"Phone numbers in Mainland China":"输入手机号或邮箱"} /> */}
            <AutoComplete
              options={options}
              onChange={(val) => handleSearch(val, setOptions)}
              popupClassName="login-account-dropdown"
              style={{ width: '100%' }}>
              <Input
                placeholder={t("输入手机号或邮箱")}
              />
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name="code"
            help={renderFieldError("sms", "code")}
            wrapperCol={{ offset: 2, span: 20 }}
            rules={[{ required: true, message: t("验证码不能为空!") }]}
          >
            <Input
              placeholder={t("验证码")}
              maxLength={6}
              suffix={
                <span
                  style={{ padding: 0 }}
                  className={disabled ? "notAllow" : ""}
                  onClick={(e)=>{e.stopPropagation()}}
                  id={captchaOpen?buttonKey:""}
                >
                  {t(tipName)}
                </span>
              }
            />
          </Form.Item>
        </Form>
        <Form
          className={pwdLogin ? "db h5-password-input-form" : "dn"}
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 20 }}
          form={form1}
          validateTrigger="onBlur"
          onFieldsChange={(changedFields, allFields) =>
            handleFieldsChange("password", changedFields, allFields)
          }
          onFinishFailed={(info) => handleFinishFailed("password", info)}
          onFinish={(data) => {
            let params = appendPrivateMemberLoginParams({
              ...data,
              loginType: "PWD",
              redirectUrl: "/team_home.html",
            });
            if (identityType) params = { ...params, identityType: 2 }
            setLoading(true)
            loginApi(params, (res) => {
              setLoading(false)
              if (isShop) {
                shopPlatFun(res.token);
                return;
              }
              loginSucCallback(res);
            }, isShop,()=>{
              setLoading(false)
            });
          }}
        >
          <Form.Item
            name="phone"
            wrapperCol={{ offset: 2, span: 20 }}
            help={renderFieldError("password", "phone")}
            getValueFromEvent={(value) => {
              if (prefixReg.test(value)) {
                return value.replace(prefixReg, '');
              }
              return value;
            }}
            rules={[
              {
                required: true,
                message: t("请输入正确的手机号或邮箱账号!"),
              },
              () => ({
                validator(_, value) {
                  let new_value = value;
                  if (prefixReg.test(value)) {
                    new_value = value.replace(prefixReg, '')
                  }
                  if (reg.test(new_value) || emailReg.test(new_value)) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("请输入正确的手机号或邮箱账号!")));
                },
              }),
            ]}
          >
            {/* <Input placeholder={i18n?.language=='en'?"Phone numbers in Mainland China or email address":"输入手机号或邮箱"} /> */}
            <AutoComplete
              options={options}
              onChange={(val) => handleSearch(val, setOptions)}
              popupClassName="login-account-dropdown"
              style={{ width: '100%' }}>
              <Input
                placeholder={t("输入手机号或邮箱")}
              />
            </AutoComplete>
          </Form.Item>
          <Form.Item
            name="password"
            type="password"
            wrapperCol={{ offset: 2, span: 20 }}
            help={renderFieldError("password", "password")}
            rules={[
              {
                required: true,
                message: t("密码不能为空!"),
              },
              () => ({
                validator(_, value) {
                  // /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/;
                  let regPwd = /^[^]{6,18}$/;
                  if (regPwd.test(value) || value == "") {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("密码至少6~18个字符")));
                },
              }),
            ]}
          >
            <Input.Password
              placeholder={t("密码")}
              iconRender={(val) =>
                !val ? (
                  <Iconfont
                    type={"icon-a-buxianshixi"}
                    style={{ width: 24, height: 24 }}
                  />
                ) : (
                  <Iconfont
                    type={"icon-a-xianshixi"}
                    style={{ width: 24, height: 24 }}
                  />
                )
              }
            />
          </Form.Item>
        </Form>
        <div className={!pwdLogin ? "" : "dn"}>
          <SliderModal
            setSlider={setSlider}
            sliderVisible={sliderVisible}
          ></SliderModal>
        </div>
        <div className={pwdLogin ? `pwdlogin bjweb-flex-space${showLegacyLoginOptions ? " h5-pwdlogin" : ""}` : "dn"}>
          {showLegacyLoginOptions && <span
            className="validateText cursor"
            onClick={switchToVerificationLogin}
          >
            {t("验证码登录/注册")}
          </span>}
          <span className="cursor" onClick={forgetPWD}>
            {t("忘记密码")}？
          </span>
        </div>
        <div>
          <span
            className={!pwdLogin && showLegacyLoginOptions ? "pwdPhoneLogin" : "dn"}
          >
            <span onClick={changeLogin} style={{ cursor: 'pointer' }} >{t("账号密码登录")}</span>
          </span>
        </div>
        <SpinLoading spinning={loading} >
          <div onClick={loginOk} className="text-wrapper_4">
            <span className={!pwdLogin ? "loginBtn" : "dn"}>{t(isPhone ? "登录" : "登录/注册")}</span>
            <span className={pwdLogin ? "loginBtn" : "dn"}>{t("登录")}</span>
          </div>
        </SpinLoading>    
        {showPrivateMemberAgreement ? renderH5Agreement() : (
          <div
            className={`text-wrapper_3 bjweb-flex-center ${i18n?.language === 'en' ? 'blod_a':''}`}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <p className="lineP" style={i18n?.language === 'zh' ? undefined : {padding: 0}}>
              <Trans
                i18nKey="注册登录协议说明"
                components={{
                  user: (
                    <a
                      href={getLocalizedAgreementHref("user")}
                      rel="noopener noreferrer"
                      target="_blank"
                    />
                  ),
                  privacy: (
                    <a
                      href={getLocalizedAgreementHref("privacy")}
                      rel="noopener noreferrer"
                      target="_blank"
                    />
                  ),
                  child: (
                    <a
                      href={getLocalizedAgreementHref("child")}
                      rel="noopener noreferrer"
                      target="_blank"
                    />
                  ),
                }}
              />
            </p>
          </div>
        )}
        {/* 微信入口：手机端在微信里走上面的 H5LoginOptions（验证码登录 | 微信登录）；
            PC 与 pad（平板跟随 PC 呈现）都走下面「其他登录方式 + 微信图标」这一块。 */}
        {showH5LoginOptions ? (
          <H5LoginOptions
            loginTextKey={pwdLogin ? "验证码登录" : "密码登录"}
            loginIconType={pwdLogin ? "icon-yanzhengmadenglu" : "icon-mimadenglu"}
            onLoginSwitch={pwdLogin ? switchToVerificationLogin : changeLogin}
            onWechatLogin={handleWechatLogin}
          />
        ) : (!isPhone && i18n?.language === 'zh' && !(prefix && devicePlatform === 'phone')) && (<><div className="otherLogin bjweb-flex-center">
          <span></span>
          <div>{t("其他登录方式")}</div>
          <span></span>
        </div>
        <div className="other_img">
          {/* <img
            onClick={(e) => {
              e.stopPropagation();
              setLoginName("盘子登录");
              setVisible(false);
              setSliderVisible(false);
              setSlider(false);
              setOtherLoginVisible(true);
            }}
            referrerPolicy="no-referrer"
            src={pzLogo}
          /> */}
          <img
            onClick={handleWechatLogin}
            referrerPolicy="no-referrer"
            src={wxLogo}
          />
          {/* <img onClick={(e) => {
            e.stopPropagation();
            queryAliPayCode().then(res => {
              if (res.success) {
                setLoginName("支付宝登录");
                setVisible(false);
                setOtherLoginVisible(true);
                window.location.href = res.result?.split("redirect:")[1]
              } else {
                message.error(t(res.errorInfo))
              }
            })
          }}
            referrerPolicy="no-referrer"
            src="https://lanhu.oss-cn-beijing.aliyuncs.com/psh3yxo7vgj76wiur5z5cp62cyapi0zkusdbd16db0-0a08-46dd-9701-089d6193a964"
          /> */}
        </div></>)}
      </div>
      {captchaOpen && <Captcha button={`#${buttonKey}`} phone={phone}  mode={'popup'} callBack={(res)=>{
        if(res){
          sendSmsCode(res)
        }
      }} />}
    </div>
  );
}

//清楚数据
const clearLocalStorage = async () => {
  if (localStorage.getItem("collectType")) {
    localStorage.removeItem("collectId")
    localStorage.removeItem("collectType")
  }
  if (localStorage.getItem("brandId")) {
    localStorage.removeItem("collectId")
    localStorage.removeItem("brandId")
  }
  if (localStorage.getItem("entrust")) {
    localStorage.removeItem("collectId")
    localStorage.removeItem("entrust")
  }

}
